import { interpolateBuPu, interpolateYlOrBr } from "d3-scale-chromatic";

// using to convert all color data in settings to hexadecimal format
function rgbToHex(rgb) {
  const [r, g, b] = rgb.match(/\d+/g).map(Number);

  // Calculate hex values
  const redHex = r * 256 * 256;
  const greenHex = g * 256;
  const blueHex = b;

  const hex = redHex + greenHex + blueHex;

  // Convert to hexadecimal and format
  return `#${(hex + 0x1000000)
    .toString(16)
    .slice(1)
    .toUpperCase()}`;
}

function getNivoColors(num, scheme) {
  const colors = [];
  for (let i = 0; i <= num; i += 1) {
    const color = scheme(i / num);
    colors.push(rgbToHex(color));
  }
  return colors;
}

// Get 9 colors in the blue-purple or yellow-orange-brown scheme
export const bluePurpleColors = getNivoColors(8, interpolateBuPu);
export const yellowOrangeBrown = getNivoColors(8, interpolateYlOrBr);

export function getGraphColors(statuses, defaultColors) {
  const colors = {};

  statuses.forEach((status, index) => {
    const key = status.name;
    let color = status.graphColor;
    if (color == null) {
      color = defaultColors[index % defaultColors.length];
    }
    colors[key] = color;
  });
  return colors;
}

export function addColorsToBarGraphData(data, colors) {
  if (!Array.isArray(data) || data.length === 0) {
    return [];
  }

  return data.map(item => {
    return {
      ...item,
      colors
    };
  });
}

export function addColorsToPieData(data, field, colors) {
  return data.map(item => {
    const key = item[field];

    return {
      ...item,
      graphColor: colors[key]
    };
  });
}
